export default __webpack_public_path__ + "images/BUTAAIR.1813ea4.png";